export const canManagePlatformTenants = (permissions: unknown): boolean =>
    Array.isArray(permissions)
    && (permissions.includes('ROLE_OPERATOR') || permissions.includes('ROLE_PLATFORM_ADMIN'));
